<template>
    <div class="shops-map relative bg-grey w-full flex-no-shrink md:w-auto md:flex-grow">
        <gmap-map
            :center="{ lat: selectedLocation.latitude, lng: selectedLocation.longitude }"
            ref="shopsMap"
            :zoom="12"
            class="absolute pin"
            @dragend="dragEnd">
            <gmap-marker
                :key="m.shopId"
                v-for="m in mapMarkers"
                :position="m.position"
                :zIndex="m.zIndex"
                :clickable="true"
                :icon="m.icon"
                @click="markerClick(m)">
            </gmap-marker>
        </gmap-map>
    </div>
</template>

<script>
import ImgMarkerRed from 'img/map-marker-red.png';
import ImgMarkerGreen from 'img/map-marker-green.png';
import { mapActions, mapState } from 'vuex';

export default {
    name: 'shops',
    data() {
        return {
            mapMarkers: [],
            mapCenter: {
                lat: 37.2091709,
                lng: -93.2503157
            }
        };
    },
    props: ['shopsListFiltered'],
    computed: {
        ...mapState('shops', ['activeShopId']),
        ...mapState('locations', [
            'selectedLocation',
            'fitBounds'
        ])
    },
    watch: {
        shopsListFiltered() {
            const markers = [];
            this.shopsListFiltered.forEach((shop) => {
                markers.push({
                    shopId: shop.shopInfo.id,
                    icon: {
                        url: ImgMarkerRed
                    },
                    position: {
                        lat: shop.coordinates.latitude,
                        lng: shop.coordinates.longitude
                    },
                    zIndex: null
                });
            });
            this.mapMarkers = markers;
        },
        mapMarkers() {
            if (this.fitBounds) {
                this.$refs.shopsMap.$mapPromise.then((map) => {
                    if (this.mapMarkers.length) {
                        const bounds = new window.google.maps.LatLngBounds();
                        this.mapMarkers.forEach((marker) => {
                            bounds.extend(marker.position);
                        });
                        if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
                            const extendPoint1 = new window.google.maps.LatLng(
                                bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01
                            );
                            const extendPoint2 = new window.google.maps.LatLng(
                                bounds.getNorthEast().lat() - 0.01, bounds.getNorthEast().lng() - 0.01
                            );
                            bounds.extend(extendPoint1);
                            bounds.extend(extendPoint2);
                        }
                        map.fitBounds(bounds);
                    }
                });
            }
        },
        activeShopId() {
            this.setMarkerInactive();
            if (this.activeShopId !== null) {
                const self = this;
                const currentMarker = this.mapMarkers.find(marker => marker.shopId === self.activeShopId);
                this.setMarkerActive(currentMarker);
            }
        }
    },
    methods: {
        ...mapActions('shops', ['setActiveShop']),
        ...mapActions('locations', ['selectSearchedLocation']),
        setMarkerInactive() {
            this.mapMarkers.forEach((marker) => {
                this.$set(marker, 'icon', ImgMarkerRed);
                this.$set(marker, 'zIndex', null);
            });
        },
        setMarkerActive(marker) {
            marker.icon = ImgMarkerGreen;
            marker.zIndex = window.google.maps.Marker.MAX_ZINDEX + 1;
        },
        markerClick(marker) {
            this.setMarkerInactive();
            this.setMarkerActive(marker);
            this.setActiveShop(marker.shopId);
        },
        dragEnd() {
            this.fitBounds = false;
            this.$refs.shopsMap.$mapPromise.then((map) => {
                const center = map.getCenter();

                this.selectSearchedLocation({
                    address: '',
                    city: '',
                    state: '',
                    zip: '',
                    latitude: center.lat(),
                    longitude: center.lng()
                }, false);
            });
        }
    }
};
</script>
